module.exports = __webpack_public_path__ + "img/Contact-Callus.png";


//////////////////
// WEBPACK FOOTER
// ./img/Contact-Callus.png
// module id = 242
// module chunks = 0